export default __webpack_public_path__ + "static/media/330_store05-fr-mobile.b5fc86a6.png";